import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Billing } from '../shared/sales-funnel-data.service';

@Injectable({ providedIn: 'root' })
export class CreditCheckService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.customerApiBase}/credit`;

  runCreditCheck(billing: Billing): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/check`, billing);
  }
}
